import http from './http'
const api = import.meta.env.VITE_APP_API;


class API {
    async get(patch, config = {}) {
        try {
            const res = await http.get(patch, config);
            return res;
        } catch (error) {
            throw error;
        }
    }

    async add(patch, params) {
        try {
            const res = await http.post(patch, params);
            return res;
        } catch (error) {
            throw error;
        }
    }

    async update(patch, params) {
        try {
            const res = await http.put(patch, params);
            return res;
        } catch (error) {

            throw error;
        }
    }
    async patch(patch, params) {
        try {
            const res = await http.patch(patch, params);
            return res;
        } catch (error) {

            throw error;
        }
    }
    async delete(patch) {
        try {
            const res = await http.delete(patch);
            return res;
        } catch (error) {

            throw error;
        }
    }

}
export default new API();